import {initElements} from "../define/shared";
import lightGallery from "lightgallery";
import lgZoom from "lightgallery/plugins/zoom";

export default function initPressimagesBlock() {
    initElements(".pressimages", block => {
        const posts = block.querySelectorAll(".post");
        const images = []

        const gallery = lightGallery(block, {
            dynamic: true,
            plugins: [lgZoom],
        });

        posts.forEach((post, index) => {
            const showMoreBtn = post.querySelector(".showMore");
            const fullscreenBtn = post.querySelector(".post-image-fullscreen");

            images.push({
                src: post.querySelector(".post-image").dataset.fullImage,
            })

            fullscreenBtn.addEventListener("click", () => {
                gallery.refresh(images)
                gallery.openGallery(index);
            });

            showMoreBtn.addEventListener("click", () => {
                const titleEl = showMoreBtn.querySelector(".link-title");
                const hiddenText = post.querySelector(".hiddenText");

                if (!showMoreBtn.classList.contains("is--clicked")) {
                    showMoreBtn.classList.add("is--clicked");
                    titleEl.innerText = "Visa mindre";
                    hiddenText.classList.add('is--shown')
                } else {
                    showMoreBtn.classList.remove("is--clicked");
                    titleEl.innerText = "Mer information om bilden";
                    hiddenText.classList.remove('is--shown')
                }
            });
        });

    });
}
